import React from "react";
import "../collaborators.css";

// Import images
import pashaLogo from "../Images/pasha.png";
import tenPearlsLogo from "../Images/10Pearls.svg";
import plan9Logo from "../Images/plan9.png";
import igniteLogo from "../Images/Ignite.png";

const collaborators = [
  { id: 1, name: "HBL Pasha ICT", logo: pashaLogo },
  { id: 2, name: "10 Pearls", logo: tenPearlsLogo },
  { id: 3, name: "Regional Plan 9", logo: plan9Logo },
  { id: 4, name: "NGIRI IGNITE", logo: igniteLogo },
];

const CollaboratorGrid = () => {
  return (
    <div className="collaborators-container">
      {collaborators.map((collaborator) => (
        <div key={collaborator.id} className="collaborator-card">
          <img
            src={collaborator.logo}
            alt={collaborator.name}
            className="collaborator-logo"
          />
          <div className="description-box">
            <h3 className="collaborator-name">{collaborator.name}</h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CollaboratorGrid;
